import Vue from 'vue';
import ResizeObserver from 'resize-observer-polyfill';

Vue.directive('elm-resize', {
  bind(el, binding, vnode) {
    if (!binding.value && typeof !binding.value !== 'function') {
      console.error('[v-elm-resize] Invalid binding value.');
      return;
    }

    let callback = binding.value;
    el._resizeRO = new ResizeObserver(callback);
    el._resizeRO.observe(el);
  },

  inserted(el, binding) {},

  update(el, binding) {},

  componentUpdated(el, binding) {},

  unbind(el, binding) {
    if (el._resizeRO) {
      el._resizeRO.disconnect();
    }
  }
});